/**
 * Header Class
 */
export class CampusesTooltips {

	tooltips;

	/**
	 * Constructor
	 *
	 * @return {void}
	 */
	constructor() {

		this.tooltips = document.querySelectorAll( '.campus-tooltip-wrapper' );

	}

	/**
	 * toggle campuses tooltips on mobile
	 *
	 */
	toggleTooltips = () => {

		if ( this.tooltips.length > 0 ) {

			this.tooltips.forEach( tooltip => {

				const tooltipContent = tooltip.querySelector( '.campus-tooltip' );

				if ( tooltipContent ) {

					this.setTooltipPosition( tooltip, tooltipContent );

					// toggle tooltip on mobile.
					tooltip.addEventListener( 'click', ( e ) => {

						e.preventDefault();

						const isMobile = window.matchMedia( '(max-width: 992px)' ).matches;

						if ( isMobile && e.target.closest( '.campus-tooltip-wrapper' ) === tooltip ) {

							// hide all tooltips.
							this.hideAllTooltips( tooltip );

							// show current tooltip.
							tooltip.classList.toggle( 'campus-tooltip-wrapper--visible' );

						}

					} )

				}

			} );

		}

	}


	/**
	 * Set tooltip position if it extends beyond the screen on the right or left side.
	 *
	 * @param {node} tooltip
	 * @param {node} tooltipContent
	 */
	setTooltipPosition = ( tooltip, tooltipContent ) => {

		const mobilePadding = 20;
		const tooltipContentWidth = tooltipContent.offsetWidth;
		const tooltipPosition = tooltip.getBoundingClientRect();
		const tooltipLeftPosition = tooltipPosition.left;
		const tooltipRightPosition = window.innerWidth - tooltipPosition.right;
		const extendLeft = tooltipLeftPosition < tooltipContentWidth / 2;
		const extendRight = tooltipRightPosition < tooltipContentWidth / 2;
		let tooltipContentPos = 0;
		let afterPos = 0;

		if ( extendLeft ) {

			tooltipContentPos = ( tooltipContentWidth / 2 ) - ( ( tooltipContentWidth / 2 ) - tooltipLeftPosition + mobilePadding );
			afterPos = tooltipLeftPosition - 8;

		}

		if ( extendRight ) {

			tooltipContentPos = ( tooltipContentWidth / 2 ) + ( ( tooltipContentWidth / 2 ) - tooltipRightPosition ) + mobilePadding;
			afterPos = tooltipContentWidth - ( tooltipRightPosition - tooltip.offsetWidth - 8 );

		}

		if ( extendLeft || extendRight ) {

			tooltipContent.style.left = `-${ tooltipContentPos }px`;
			tooltipContent.style.transform = 'none';
			tooltipContent.style.setProperty( '--campus-tooltip-after-position', `${ afterPos }px` );

		}

	}

	/**
	 * Hide all campuses tooltips, except current one
	 *
	 * @param {node} tooltip
	 */
	hideAllTooltips = ( tooltip ) => {

		this.tooltips.forEach( ( singleTooltip ) => {

			const notRemove = tooltip === singleTooltip && tooltip.classList.contains( 'campus-tooltip-wrapper--visible' );

			if ( ! notRemove ) {

				singleTooltip.classList.remove( 'campus-tooltip-wrapper--visible' );

			}

		} );

	}

}
